// DESCRIPTION: Admin wrapper component for creating a new event.
// Delegates to EventFormWizard in 'create' mode and handles save/cancel callbacks.
import EventFormWizard from './wizard/EventFormWizard';

/**
 * Create Event Form
 *
 * Wrapper around EventFormWizard for new event creation in the admin SPA.
 *
 * @param {Object}   props
 * @param {Function} props.onSave   - Called after the event is successfully created, receives the saved event.
 * @param {Function} props.onCancel - Called when the user cancels event creation (navigates back).
 */
const CreateEventForm = ( { onSave, onCancel } ) => {
	return (
		<EventFormWizard
			mode="create"
			onSave={ onSave }
			onCancel={ onCancel }
		/>
	);
};

export default CreateEventForm;
